import React, { useEffect, useState } from "react";
import "./index.less";
import { Carousel, CarouselProps, Image } from "antd";
import { getBannerList } from "@/api/freeDownload";
import banner from "@/assets/images/svg/banner.svg";
import loadFail from "@/assets/images/svg/loadFail.svg";
interface BannerProps {
  // Define your props here
  pageKey: string; //页面标识
  carouselConfig?: CarouselProps;
  contentSlot?: (...data: any) => React.ReactNode; //内容插槽
  getList?: () => Promise<any>; //获取列表
  isPlaceholder?: boolean; //是否显示占位图
}

const prefix = "banner";

const ImageBanner: React.FC<any> = (props) => {
  const { imgUrl,loadHandle } = props;
  const onImgLoad = (e:any) => {
    // console.log("onImgLoad",e);
    loadHandle && loadHandle(e);
  }
  return <Image src={imgUrl} preview={false} fallback={loadFail} onLoad={onImgLoad} />;
}

/**
 * banner 组件
 * @param props
 * @returns
 */
const Banner: React.FC<BannerProps> = (props) => {
  const { pageKey = "home", carouselConfig = {}, contentSlot, getList, isPlaceholder = false } = props;
  const [bannerList, setBannerList] = useState<any[]>([]);
  const [isBannerVisible, setIsBannerVisible] = useState<boolean>(false);
  const bannerBoxClassName= `${isBannerVisible ? bannerList.length==0? 'banner-box-hidden': "banner-show" : "banner-hidden"}`;

  const imgLoadHandle = (e:any) => {
    // console.log("imgLoadHandle",e);
    if(isBannerVisible) return;
    setIsBannerVisible(true);
  }

  useEffect(() => {
    const getBannerData = getList ? getList() : getBannerList(pageKey);
    getBannerData.then((res: any) => {
      if (res.code === 200) {
        setBannerList(res.result);
        // setTimeout(() => {
        //   setIsBannerVisible(true);
        // }, 200);
      }
    }).catch((err)=>{
      console.error(err);
    });
  }, []);

  return (
    <div className={`${prefix}`}>

      <div className={bannerBoxClassName}>
        {isPlaceholder && <img className={`${isBannerVisible ? "hide" : ""} banner-placeholder`} src={banner} alt="" />}
        <Carousel autoplay={bannerList.length > 1}  {...carouselConfig}>
          {bannerList?.map((item: any, index: number) => {
            return (
              <div key={index} className={`${prefix}-box`}>
                {contentSlot ? (
                  contentSlot(item)
                ) : (
                  <>
                    {item.toUrl ? (
                      <a href={item.toUrl} target="_blank" rel="noreferrer">
                        <ImageBanner imgUrl={item.imgUrl} loadHandle={imgLoadHandle} />
                      </a>
                    ) : (
                      <ImageBanner imgUrl={item.imgUrl} loadHandle={imgLoadHandle}/>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};

export default Banner;
